import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import React, {useEffect, useState} from 'react';
import {NotificationManager} from 'react-notifications';
import {StyledNewRewards} from '../rewards/rewards.styled';
import {hideLoader, showLoader} from '../../store/common/slice';

import 'react-notifications/lib/notifications.css';
import {useAccessToken} from '../../common/hooks/useAccessToken';
import PrizesList from '../rewards/PrizesList';
import {constants} from "../../common/constants/constants";
const hardCodedServerResponse = require('./markplaceProducts.json');

export default function MarketPlace() {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const userProfile = useSelector((state) => state.auth.userProfile);
    const ltr = useSelector((state) => state.common.ltrEnabled);

    const [campaign, setCampaign] = useState({});
    const [balance, setBalance] = useState({});
    const [products, setProducts] = useState({});
    const [selectedPrizeId, setSelectedPrizeId] = useState();

    const client = useAccessToken();

    const textOverrides = {
        buttonText: t('manager_rewards.collect_marketplace_product'),
        title: t('manager_rewards.collect_marketplace_title'),
        currency: t('manager_rewards.collect_marketplace_currency'),
        detailsPopUpTitle: t('manager_rewards.collect_marketplace_popup_title'),
        detailsPopUpConfirm: t('reports.delete.btns.confirm'),
        detailsPopUpExplainText: t('manager_rewards.collect_marketplace_popup_explain'),
    };

    useEffect(async () => {
        if (client != null && userProfile.userFirstName != null) {
            dispatch(showLoader());
            const partnerID = (userProfile.partnerID ?? '').toLowerCase();
            try {
                await loadCurrentCampaigns();
            } catch (e) {
                console.error(e);
            } finally {
                dispatch(hideLoader());
            }
        }
    }, [client, userProfile]);

    const loadCurrentCampaigns = async () => {
        await setServerResponse(hardCodedServerResponse);
    }



    const setServerResponse = async (response) => {
        const campaigns = response?.campaigns || [];
        const coinBalance = response?.coinBalance || [];
        campaigns[0]?.Prizes?.length > 0 && campaigns[0].Prizes.sort((a, b) => a.coinValue - b.coinValue);
        setCampaign(campaigns[0] || {});
        setBalance(coinBalance[0]);
        setProducts(campaigns[0].Prizes);
    }

    const collectPrize = async (rewardDetails = {}) => {
        dispatch(showLoader());

        const selectedReward = products.find(obj => obj.campaignPrizeId === selectedPrizeId);
        await sendInternalMail(rewardDetails,  selectedReward);
        NotificationManager.success(t('manager_rewards.collect_marketplace_product_success'), '', 7000);

        dispatch(hideLoader());
        return true;
    }

    const sendInternalMail = async (rewardDetails, selectedReward) => {

        const query = ''; // dont_care=true
        let fullName = rewardDetails.fullName;
        const params = {
            sendTo: ["rayee@bllink.co", "mord@bllink.co", "ohad@bllink.co"],
            title:  `Subject: user ${fullName} collected a product from the marketPlace`,
            content: `user ${fullName} collected a product  from the marketPlace <br>` +
                `The Product is ${selectedReward?.Details?.name} <br>` +
                `form details: ${JSON.stringify(rewardDetails)}`
        };
        await client.tenants.utils.postInternalEmail(constants.backendEndpoints.GENERIC_INTERNAL_EMAIL_ENDPOINT ,query , params);
    }

    return (
        <StyledNewRewards className={'rewards'} ltr={ltr}>
            <h1 className={'page-title'}>
                <span>{t('manager_rewards.titleMarketPlace')}</span>
            </h1>

            <PrizesList
                prizes={campaign.Prizes}
                balance={balance}
                selectedPrizeId={selectedPrizeId}
                setSelectedPrizeId={setSelectedPrizeId}
                textOverrides={textOverrides}
                collectPrize={collectPrize}
                canCollect={false}
                ltr={ltr}
            />

        </StyledNewRewards>
    )
};
